import { FOOD, SCENE, BRAND } from "@/data/media";

export const SITE = {
  brand: "Chef Jomon's #VEEDU",
  tagline: "Come and listen to the food tales of Kerala",
  heroSupport:
    "A Kerala-inspired culinary house in the heart of Hornchurch, Essex.",
  address: {
    line1: "197-201 High Street",
    city: "Hornchurch",
    county: "Essex",
    postcode: "RM11 3XT",
    full: "197-201 High Street, Hornchurch, Essex RM11 3XT",
  },
  parking: "Nearest parking: Fentiman Way Car Park, RM11 1QX (2 Min Walking)",
  phones: {
    director: "+44 (0) 7445 141 536",
    restaurant: "+44 (0) 1708 438 003",
  },
  chef: {
    name: "Chef Jomon",
    role: "Director of Culinary | Founder",
    website: "https://www.chefjomon.com/",
    wiki: "https://en.wikipedia.org/wiki/Jomon_Kuriakose",
  },
  social: [
    { label: "Instagram", href: "https://www.instagram.com/chefjomon/?hl=en" },
    { label: "Facebook", href: "https://www.facebook.com/chefjomon/" },
    { label: "Wikipedia", href: "https://en.wikipedia.org/wiki/Jomon_Kuriakose" },
    { label: "Website", href: "https://www.chefjomon.com/" },
    { label: "X", href: "https://x.com/chefjomon?lang=en" },
  ],
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Our Story", to: "/story" },
  { label: "Menu", to: "/menu" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const CULINARY_SIGNATURE = [
  { n: "01", title: "From the Coast", note: "Seafood, coconut, tamarind, curry leaf." },
  { n: "02", title: "From the Fire", note: "Charcoal, smoke, embers, bird's-eye chilli." },
  { n: "03", title: "From the Land", note: "Slow-braised meat, roasted spice, ghee." },
  { n: "04", title: "From the Tandoor", note: "Clay heat, char, marinade, warmth." },
  { n: "05", title: "From the Kitchen", note: "Memory, family, hands, patience." },
];

export const ARCH_LABELS = [
  { label: "Timber Frame", note: "Original exposed structural oak." },
  { label: "Clay Tile Roof", note: "Traditional interlocking clay tiles." },
  { label: "Exposed Structure", note: "Centuries-old English carpentry." },
  { label: "Historic Fireplace", note: "Surviving hearths of an older life." },
  { label: "Kerala Nalukettu", note: "Built around an open courtyard." },
];

export const MANIFESTO = [
  { n: "I", line: "#VEEDU means home." },
  { n: "II", line: "Home is memory. Home is food." },
  { n: "III", line: "Kerala meets Essex. India meets Britain." },
  { n: "IV", line: "A house becomes a restaurant." },
  { n: "V", line: "A restaurant becomes a story." },
];

export const GALLERY = [
  {
    chapter: "The House",
    caption: "Architecture, timber, roof, heritage details.",
    src: "/images/veedu3.png",
    contain: false,
    size: "wide",
  },
  { chapter: "The Kitchen", caption: "Fire, tandoor, embers, smoke.", src: FOOD.tandoorFire, size: "tall" },
  { chapter: "The Table", caption: "Warm light, ceramics, hospitality.", src: SCENE.tableSetting, size: "wide" },
  { chapter: "The Details", caption: "Spice, coconut, curry leaf.", src: FOOD.spices, size: "wide" },
  { chapter: "The Kitchen", caption: "The chef's hand, the final touch.", src: SCENE.chefPlating, size: "tall" },
  { chapter: "The Table", caption: "Coastal scallops, plated.", src: FOOD.scallops, size: "tall" },
  { chapter: "The Details", caption: "Kottayam fish curry.", src: FOOD.fishCurry, size: "tall" },
  { chapter: "The House", caption: "A room lit for the evening.", src: SCENE.interiorWarm, size: "wide" },
  { chapter: "The Table", caption: "Malabar biriyani, copper handi.", src: FOOD.biriyani, size: "wide" },
  { chapter: "The Kitchen", caption: "Layered Kerala breads.", src: FOOD.breads, size: "wide" },
  { chapter: "The Details", caption: "Sweet paan, to finish.", src: FOOD.dessert, size: "tall" },
];
